import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";
import PaginationGroup from "./Pagination";
import Table from "react-bootstrap/esm/Table";

export type DataTableColumn<T> = {
    column: string;
    label: string;
    headerClassName?: string;
    cellClassName?: string;
    sortable?: boolean;
    accessor?: (row: T) => any | undefined;
    headerStyle?: object;
    cellStyle?: object;
};

export type DataTableProps<T> = {
    data: T[];
    columns: DataTableColumn<T>[];
    id: string;
    page: number;
    pageSize: number;
    totalRecords: number;
    tableClassName?: string;
    tableStyle?: object;
    responsive?: boolean;
    onSort?: (column: DataTableColumn<T>) => void;
    onPageChange?: (page: number) => void;
    sort?: { column: string | null; direction: "asc" | "desc" | "none" };
    handlePageSizeChange?: (itemsPerPage: number) => void;
};

const DataTable = <T extends Record<string, unknown>>(props: DataTableProps<T>) => {
    const totalPages = Math.ceil(props.totalRecords / props.pageSize);

    

    return (
        <div id={props.id} style={{ width: "100%" }}>
            <Table
                className={props.tableClassName}
                id={props.id}
                responsive={props.responsive ?? true}
                style={props.tableStyle}
            >
                <thead>
                    <tr>
                        {props.columns.map((col, index) => {
                            let thClass = col.headerClassName? col.headerClassName : "";
                            return (
                                <th
                                    className={thClass}
                                    style={col.headerStyle}
                                    key={`th_${index}`}
                                    onClick={() => props.onSort ? props.onSort(col) : {}}
                                >
                                    <div className="d-flex gap-2 align-items-center">
                                        <div>{col.label}</div>
                                        {props.sort?.column === col.column && props.sort.direction === 'asc' &&
                                            <CaretUpFill className="text-secondary"/>
                                        }
                                        {props.sort?.column === col.column && props.sort.direction === 'desc' &&
                                            <CaretDownFill className="text-secondary"/>
                                        }
                                    </div>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody className="table-body">
                    {props.data.map((row, rowIndex) => (
                        <tr className="table__row" key={`row_${rowIndex}`}>
                            {props.columns.map((col, colIndex) => (
                                <td className={`${col.cellClassName? col.cellClassName : ""}`} key={`col_${colIndex}`} style={col.cellStyle}>
                                    {/* display col name here on xs screens */}
                                    {props.tableClassName?.includes("table-stack-xs") &&
                                        <h6 className="td-xs-lbl d-sm-none"><b>{col.label}</b></h6>
                                    }
                                    <div className="td-xs-content">
                                        {col.accessor
                                            ? col.accessor(row)
                                            : row[col.column]
                                        }
                                    </div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
            {props.handlePageSizeChange && 
                    <PaginationGroup
                        page={props.page}
                        totalPages={totalPages}
                        onPageChange={props.onPageChange ?? (() => {})}
                        id={props.id}
                        itemsPerPage={props.pageSize}
                        onItemsPerPageChange={props.handlePageSizeChange}
                    />
            }
            
            
        </div>
    );
};

export default DataTable;